import type Highcharts from "highcharts";

declare module "highcharts" {
  interface Chart {
    fixedDiv?: HTMLDOMElement;
    scrollingContainer?: HTMLDOMElement;
    scrollableMask?: SVGElement;
    scrollablePixelsX?: number;
    scrollablePixelsY?: number;
    applyFixed(): void;
    moveFixedElements(): void;
  }
}

export default function fixScrollablePlotArea(H: typeof Highcharts) {
  H.wrap(
    H.Chart.prototype,
    "applyFixed",
    function (
      this: Highcharts.Chart,
      proceed: { apply: (arg0: Highcharts.Chart, arg1: [Highcharts.Options]) => void },
      ...args: [Highcharts.Options]
    ) {
      proceed.apply(this, args);
      if (!this.scrollableMask || this.scrollablePixelsX === undefined) return;
      const oldPath = this.scrollableMask.attr("d") as string;
      const newPath = oldPath.split("M").slice(0, 2).join("M");
      window.requestAnimationFrame(() => {
        if (this.scrollableMask) {
          this.scrollableMask.attr({ d: newPath }); // remove last part of the scrollableMask
          this.moveFixedElements(); // it doesn't get called on chart updates, move the axis label to the fixed layer
        }
      });
    },
  );
}
